import { render, staticRenderFns } from "./ChBaccDetail.vue?vue&type=template&id=f9a50f2a"
import script from "./ChBaccDetail.vue?vue&type=script&lang=js"
export * from "./ChBaccDetail.vue?vue&type=script&lang=js"
import style0 from "./ChBaccDetail.vue?vue&type=style&index=0&id=f9a50f2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports